import clsx from 'clsx'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../parts/crud/Form'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';
import { useState } from 'react';

const MySwal = withReactContent(Swal)
export const TenantForm = () => {

  const [redirect, setRedirect] = useState("")
  return (
    <>
    {redirect !== "" ? <Navigate to={redirect}></Navigate> : <></>}
      <CrudProvider api='tenants'>
        <FormComponent
          fetch={{db_host: 'tenants/db_hosts'}}
          redirect='/tenants'
          text_modificato='Tenant modificato con successo'
          text_nuovo='Tenant creato con successo'
          errorHook={(error:any) => {
            console.log(error)
            if(error.code === "CREATE_TENANT_ERROR"){
              MySwal.fire({
                title: 'Errore',
                text: error.errorMsg,
                icon: 'error',
              }).then(() => {
                setRedirect('/tenants')
              }
              )

            }
          }}
        >
          {(formik, data, remoteErrors, isEdit) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='group_key' className='required fw-bold fs-6'>
                      Chiave alfanumerica
                    </label>
                    <input
                      type='text'
                      disabled={isEdit}
                      className={clsx('form-control ', {
                        'is-invalid':
                          (formik.touched.group_key && formik.errors.group_key) ||
                          remoteErrors.group_key !== undefined,
                        'is-valid':
                          formik.touched.group_key &&
                          !formik.errors.group_key &&
                          remoteErrors.group_key === undefined,
                      })}
                      id='group_key'
                      {...formik.getFieldProps('group_key')}
                    />
                    {formik.touched.group_key && formik.errors.group_key ? (
                      <em className='text-danger'>{formik.errors.group_key}</em>
                    ) : null}
                    {remoteErrors.group_key !== undefined ? (
                      <em className='text-danger'>{remoteErrors.group_key}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='group_name' className='required fw-bold fs-6'>
                      Nome
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid':
                          (formik.touched.group_name && formik.errors.group_name) ||
                          remoteErrors.group_name !== undefined,
                        'is-valid':
                          formik.touched.group_name &&
                          !formik.errors.group_name &&
                          remoteErrors.group_name === undefined,
                      })}
                      id='group_name'
                      {...formik.getFieldProps('group_name')}
                    />
                    {formik.touched.group_name && formik.errors.group_name ? (
                      <em className='text-danger'>{formik.errors.group_name}</em>
                    ) : null}
                    {remoteErrors.group_name !== undefined ? (
                      <em className='text-danger'>{remoteErrors.group_name}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='db_instance' className='required fw-bold fs-6'>
                      Istanza database
                    </label>
                    <select
                    disabled={isEdit}
                      className={clsx('form-control ', {
                        'is-invalid':
                          (formik.touched.db_instance && formik.errors.db_instance) ||
                          remoteErrors.db_instance !== undefined,
                        'is-valid':
                          formik.touched.db_instance &&
                          !formik.errors.db_instance &&
                          remoteErrors.db_instance === undefined,
                      })}
                      id='db_instance'
                      {...formik.getFieldProps('db_instance')}
                    >
                        <option value=''>Seleziona un'istanza</option>
                        {data.db_host.map((item: any) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    {formik.touched.db_instance && formik.errors.db_instance ? (
                      <em className='text-danger'>{formik.errors.db_instance}</em>
                    ) : null}
                    {remoteErrors.db_instance !== undefined ? (
                      <em className='text-danger'>{remoteErrors.db_instance}</em>
                    ) : null}
                  </div>
                </div>
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
